import { useEffect, useState } from "react";
import { CounterInputV2 } from "../../../FormControlsV2";
import { MessageBalloon } from "../../../MessageBalloon/Index";
import { ReactComponent as PointIcon } from "../../../../assets/svg/icons/point.svg";
import { ReactComponent as AreaIcon } from "../../../../assets/svg/icons/areaIcon.svg";
import { ReactComponent as AnimalsIcon } from "../../../../assets/svg/icons/animais.svg";
import { ReactComponent as GrassIcon } from "../../../../assets/svg/icons/grass.svg";
import { ButtonPressed } from "../../../Buttons/ButtonPressed";
import { ButtonYesOrNo } from "../../../Buttons/ButtonYesOrNo";
import { format } from "date-fns";
import { parseUtcDate } from "../../../../utils/date/formatedDate";

interface InfoSoilPreparationProps {
  task: ITaskSoilPreparation | undefined;
}

export default function InfoSoilPreparation(task: InfoSoilPreparationProps) {
  const [taskSoilPreparation, setTaskSoilPreparation] =
    useState<ITaskSoilPreparation>();
  const hasSkipReason = taskSoilPreparation?.skip_reason != null;

  useEffect(() => {
    setTaskSoilPreparation(task.task);
  }, []);

  return (
    <>
      <div>
        <span>No pasto</span>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <GrassIcon width={30} className="iconInitialTaskInfo" />
          <div className="labelInitialTaskInfo">
            <span>{taskSoilPreparation?.initials}</span>
            <PointIcon width={15} />
          </div>
        </div>
      </div>

      <div className="containerQuestion">
        <MessageBalloon text={`A tarefa foi iniciada?`} pointed />
        <ButtonYesOrNo
          onlyResult
          optionSelected={hasSkipReason ? "no" : "yes"}
        />
      </div>

      {hasSkipReason ? (
        <MessageBalloon text={`${taskSoilPreparation?.skip_reason}`} answer />
      ) : (
        <>
          {taskSoilPreparation?.machine_type && (
            <MessageBalloon text={taskSoilPreparation.machine_type} pointed />
          )}

          <MessageBalloon
            text={`${format(parseUtcDate(taskSoilPreparation?.start_time) || 0, "dd/MM/yyyy - HH:mm")}`}
          />

          <MessageBalloon text={`Informar horímetro inicial`} />
          <CounterInputV2
            name="info-soil-initial-h"
            suffix="h"
            value={Number(taskSoilPreparation?.initial_hour_meter ?? 0)}
            disabled
          />

          <ButtonPressed
            onlyResult
            optionSelected={1}
            value={1}
            text={`Horímetro final`}
          />

          <MessageBalloon
            text={`${format(parseUtcDate(taskSoilPreparation?.end_time) || 0, "dd/MM/yyyy - HH:mm")}`}
          />

          <MessageBalloon text={`Informar horímetro final`} />
          <CounterInputV2
            name="info-soil-final-h"
            suffix="h"
            value={Number(taskSoilPreparation?.final_hour_meter ?? 0)}
            disabled
          />
        </>
      )}
    </>
  );
}
